

 //ハンバーガーアコーディオンをクリックした時の動作
$('.hum__item-parents').on('click', function() {//タイトル要素をクリックしたら
	var findElm = $(this).next("ul");//直後のアコーディオンを行うエリアを取得し
	$(findElm).slideToggle();//アコーディオンの上下動作
    
	if($(this).hasClass('ham_close')){//タイトル要素にクラス名closeがあれば
		$(this).removeClass('ham_close');
	}else{
		$(this).addClass('ham_close');
	}
});


//headerの背景をつけたい
  function PageTopAnimeheader() {
	var scroll = $(window).scrollTop();
	if (scroll >= 100){//上から200pxスクロールしたら
		$('.header').addClass('header-top');
		$('.side-menu,.result').addClass('side-top');
	} else{
		if(scroll <= 200){//上から200pxスクロールしたら
			$('.header').removeClass('header-top');
			$('.side-menu,.result').removeClass('side-top');
	}
	}
}
$(window).scroll(function () {
	PageTopAnimeheader();/* スクロールした際の動きの関数を呼ぶ*/
});


//ログインモーダルタブ----------------------------------------------------
function GethashID (hashIDName){
	if(hashIDName){
		//タブ設定
		$('.login-wrap li').find('a').each(function() { //タブ内のaタグ全てを取得
			var idName = $(this).attr('href'); //タブ内のaタグのリンク名（例）#lunchの値を取得	
			if(idName == hashIDName){ //リンク元の指定されたURLのハッシュタグ（例）http://example.com/#lunch←この#の値とタブ内のリンク名（例）#lunchが同じかをチェック
				var parentElm = $(this).parent(); //タブ内のaタグの親要素（li）を取得
				$('.login-wrap li').removeClass("active"); //タブ内のliについているactiveクラスを取り除き
				$(parentElm).addClass("active"); //リンク元の指定されたURLのハッシュタグとタブ内のリンク名が同じであれば、liにactiveクラスを追加
				//表示させるエリア設定
				$(".area").removeClass("is-active"); //もともとついているis-activeクラスを取り除き
				$(hashIDName).addClass("is-active"); //表示させたいエリアのタブリンク名をクリックしたら、表示エリアにis-activeクラスを追加	

			}
		});
	}
}
//タブをクリックしたら
$('.login-wrap a').on('click', function() {
	var idName = $(this).attr('href'); //タブ内のリンク名を取得	
	GethashID (idName);//設定したタブの読み込みと
	return false;//aタグを無効にする
});


// 上記の動きをページが読み込まれたらすぐに動かす
$(window).on('load', function () {
	var hashName = location.hash; //リンク元の指定されたURLのハッシュタグを取得
	GethashID (hashName);//設定したタブの読み込み
});



//会員登録モーダルタブ-----------------------------------------------------------------
function GethashID2 (hashIDName2){
	if(hashIDName2){
		//タブ設定
		$('.registration-wrap li').find('a').each(function() { //タブ内のaタグ全てを取得
			var idName = $(this).attr('href'); //タブ内のaタグのリンク名（例）#lunchの値を取得	
			if(idName == hashIDName2){ //リンク元の指定されたURLのハッシュタグ（例）http://example.com/#lunch←この#の値とタブ内のリンク名（例）#lunchが同じかをチェック
				var parentElm2 = $(this).parent(); //タブ内のaタグの親要素（li）を取得
				$('.registration-wrap li').removeClass("active"); //タブ内のliについているactiveクラスを取り除き
				$(parentElm2).addClass("active"); //リンク元の指定されたURLのハッシュタグとタブ内のリンク名が同じであれば、liにactiveクラスを追加
				//表示させるエリア設定
				$(".area2").removeClass("is-active"); //もともとついているis-activeクラスを取り除き
				$(hashIDName2).addClass("is-active"); //表示させたいエリアのタブリンク名をクリックしたら、表示エリアにis-activeクラスを追加
			}
		});
	}
}
//タブをクリックしたら
$('.registration-wrap a').on('click', function() {
	var idName2 = $(this).attr('href'); //タブ内のリンク名を取得	
	GethashID2 (idName2);//設定したタブの読み込みと
	return false;//aタグを無効にする
});


// 上記の動きをページが読み込まれたらすぐに動かす
$(window).on('load', function () {
	var hashName2 = location.hash; //リンク元の指定されたURLのハッシュタグを取得
	GethashID2 (hashName2);//設定したタブの読み込み.
});

// マイページheaderメッセージに未読アイコンが付いた時のパディング調整用
$(".mypage-mess:has(span)").addClass("icon");
